import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';

import { PAGE_TYPES } from '_enums/page-types';

import { fetchPageContent } from '_redux/actioncreators/page';

import Home from '../pages/Home';
import HowItWorks from '../pages/HowItWorks';
import FindAnEvent from '../pages/FindAnEvent';
import Prizes from '../pages/Prizes';
import Gallery from '../pages/Gallery';
import M12Stubby from '../pages/M12Stubby';
import Loader from '../general/Loader';

class PageContainer extends Component {
  constructor(props) {
    super(props);
    props.fetchPageContent(props.cultureCode, props.contentClassName);
  }

  componentDidUpdate(prevProps) {
    if (this.props.page.content.contentClassName !== prevProps.page.content.contentClassName) {
      this.updateMetadata();
      this.logPageView();
    }
  }

  render() {
    if (this.props.page.contentLoading === true) {
      return (
        <div className="thunderbolt__page">
          <Loader></Loader>;
        </div>
      );
    }

    switch (this.props.contentClassName) {
      case PAGE_TYPES.HOME:
        return <Home
          cultureCode={this.props.cultureCode}
          toggleLeaderboard={this.props.toggleLeaderboard}
          leaderboard={this.props.leaderboard}
          page={this.props.page}>
        </Home>;

      case PAGE_TYPES.HOW_IT_WORKS:
        return <HowItWorks cultureCode={this.props.cultureCode} page={this.props.page}></HowItWorks>;

      case PAGE_TYPES.FIND_AN_EVENT:
        return <FindAnEvent cultureCode={this.props.cultureCode}></FindAnEvent>;

      case PAGE_TYPES.PRIZES:
        return <Prizes
          cultureCode={this.props.cultureCode}
          page={this.props.page}>
        </Prizes>;

      case PAGE_TYPES.GALLERY:
        return <Gallery cultureCode={this.props.cultureCode}></Gallery>;

      case PAGE_TYPES.M12_STUBBY_WRENCH:
        return <M12Stubby cultureCode={this.props.cultureCode} page={this.props.page}></M12Stubby>;

      default:
        return null;
    }
  }

  updateMetadata = () => {
    const { documentPageTitle, documentPageDescription, documentPageKeyWords } = this.props.page.content.contentFields;

    if (this.isValidMetaContent(documentPageTitle)) {
      document.title = documentPageTitle;
    }

    if (this.isValidMetaContent(documentPageKeyWords)) {
      const keywords = document.querySelector("meta[name='keywords']");
      keywords.setAttribute('content', documentPageKeyWords);
    }

    if (this.isValidMetaContent(documentPageDescription)) {
      const description = document.querySelector("meta[name='description']");
      description.setAttribute('content', documentPageDescription);
    }

    const html = document.querySelector('html');
    html.setAttribute('lang', this.props.cultureCode.substring(0, 2));
  }

  ensureGoogleAnalytics = () => {
    if (window.ga) {
      return false;
    }

    const { gaAnalyticsCode } = this.props.page.content.contentFields;

    if (gaAnalyticsCode && gaAnalyticsCode.trim() !== '') {
      ReactGA.initialize(gaAnalyticsCode);
      return true;
    }

    return false;
  }

  logPageView = () => {
    if (this.ensureGoogleAnalytics()) {
      ReactGA.set({
        location: window.location.origin + window.location.pathname,
      });

      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  }

  isValidMetaContent(value) {
    return value !== null && value !== '' && value !== undefined && value !== 'null';
  }

  replacePatternToComponent(text, pattern, component) {
    const splitText = text.split(pattern);
    const matches = text.match(pattern);

    if (splitText.length <= 1) {
      return text;
    }

    return splitText.reduce((arr, element) => {
      if (!element) return arr;

      if (matches.includes(element)) {
        return [...arr, component];
      }

      return [...arr, element];
    }, []);
  }
}

const mapStateToProps = state => ({
  page: state.app.page,
  leaderboard: state.app.leaderboard,
});

const mapDispatchToProps = dispatch => ({
  fetchPageContent: (cultureCode, contentClassName) => dispatch(fetchPageContent({ cultureCode, contentClassName })),
});


export default connect(mapStateToProps, mapDispatchToProps)(PageContainer);
